import styled from "styled-components";

export const ChatbotPopUpInfo = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  .header {
    padding: 10px 20px;
    border-bottom: 1px solid #EFEFF9;
    display: flex;
  }
  .info {
    flex: 1;
    overflow: auto; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    &__principal {
      padding-left: 20px;
      display: flex;
      margin-bottom: 30px;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
    }
    &__titles {
      display: flex;
      flex-direction: column;
      color: #1F1F52;
      .title {
        font-family: Nunito Sans Light;
        font-size: 25px;
      }
      .subtitle {
        font-family: Nunito Sans Bold;
        font-size: 17px;
      }
    }
    &__secondary {
      padding: 0 20px 20px 20px;
      flex: 1;
      overflow: auto; 
      font-family: Nunito Sans;
      font-size: 20px;
      color: #707582;
    }
  }
`
